export const PROJECTS_SEARCH_QUERY_KEY = 'projects-search-query-key';
export const TRADES_SEARCH_QUERY_KEY = 'trades-search-query-key';
